"use client";

import { misc, util } from "@/common/theme";
import { SectionTitle } from "@/components/SectionTitle";
import { mediaMobile } from "@/mono/lib/responsive";
import { setTypography } from "@/mono/lib/styles/mixins";
import SplitText from "mono/components/SplitText";
import styled from "styled-components";

export default function ProjectHeader({ title, data, __typename }) {
  const isProject = __typename === "ProjectRecord";
  const displayTitle = data.bigTitle || title;
  const sectionTitle =
    data.sectionTitle ||
    (isProject ? "About the project" : "About the campaign");

  return (
    <>
      <SectionTitle>{sectionTitle}</SectionTitle>
      <Wrapper $isProject={isProject}>
        <div className="project-detail__header-title">
          <SplitText tag="h1" animateOnScroll={true}>
            {displayTitle}
          </SplitText>
        </div>

        <div className="project-detail__header-paragraph">
          <SplitText tag="h6" animateOnScroll={true}>
            {data.paragraphHeader}
          </SplitText>
          <SplitText tag="p" animateOnScroll={true}>
            {data.paragraph}
          </SplitText>
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  ${util.inner}

  ${({ $isProject }) =>
    !$isProject &&
    `
    display: flex;

    .project-detail__header-title {
      width: ${misc.pageHalfWidth};
    }

    .project-detail__header-paragraph {
      width: calc(100% - ${misc.pageHalfWidth});
    }
  `}

  ${({ $isProject }) =>
    $isProject &&
    `
    .project-detail__header-paragraph {
      margin-left: 55%;
    }
  `}

  h1 {
    display: block;
    color: ${({ theme }) => theme.theme.floatingTitle};
    ${setTypography("floatingTitle")}
  }

  h6,
  p {
    max-width: 90%;
    ${setTypography("paragraph")}
  }

  h6 {
    font-weight: 500;
    margin-bottom: 30rem;
  }

  ${mediaMobile(`
    display: block;

    h1 {
      text-align: right;
    }

    h6 {
      margin-bottom: 0;
    }

    .project-detail__header-title {
      width: 100%;
      margin-bottom: 150rem;
    }

    .project-detail__header-paragraph {
      width: 100%;
      margin-left: 0;
    }
  `)}
`;
